module.exports = __webpack_public_path__ + "img/Roboto-Italic.921def26.svg";